module.exports = __webpack_public_path__ + "static/assets/bd403d3810d73d1b64a27b08c8bf6d2e.svg";